<template>
  <div class="content">

    <el-row class="bgW">
      <el-col :span="22">
        <!--检索条件-->
        <el-form class="search" :inline="true" label-suffix="：" size="mini" :model="search">
          <el-form-item label="商品名称">
            <el-input
              v-model="search.name"
              clearable
              maxlength="30"
              placeholder="请输入商品名称"
            />
          </el-form-item>
          <el-form-item label="商品类型" >
            <el-select
              v-model="search.is_project"
              multiple
              placeholder="请选择商品类型"
            >
              <el-option
                v-for="item in options.is_projectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="商品编码">
            <el-input
              v-model="search.kingdee_code"
              maxlength="30"
              placeholder="请输入商品编码"
            />
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="search.status"
              clearable
              placeholder="请选择状态"
            >
              <el-option
                v-for="item in options.status"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          
          <el-form-item label="认领状态" v-if="![1,1752, 1737, 1901, 1916, 1917].includes(userInfo.id)">
            <el-select
              v-model="search.claim_status"
              clearable
              placeholder="请选择认领状态"
            >
              <el-option
                v-for="item in options.claim_statusList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="是否预存货">
            <el-select
              v-model="search.is_prestock"
              clearable
              class="w100"
              placeholder="请选择是否预存"
            >
              <el-option
                v-for="item in options.is_prestock"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="商品分类" prop="category_id">
            <el-select
              v-model="search.category_id"
              clearable
              multiple
              placeholder="请选择商品分类"
            >
              <el-option
                v-for="item in options.category_id"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="商品权限"  v-if="userInfo.group_id == 96 ||  [1, 1737, 1901, 1916, 1917].includes(userInfo.id)">
            <el-select
              v-model="search.goods_level"
              clearable
              placeholder="请选择商品权限"
            >
              <el-option
                v-for="item in options.goods_level"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          
          <el-form-item label="商品归属"  v-if="userInfo.group_id == 96 ||  [1, 1737, 1901, 1916, 1917].includes(userInfo.id)">
            <el-cascader
              v-model="search.shop_type"
              class="w200"
              clearable
              :options="options.shop_typeList"
              placeholder="请选择门店分类"
              :props="{
                children: 'children',
                label: 'name',
                value: 'id',
                multiple: true,
                emitPath: false
              }"
            >
            </el-cascader>
          </el-form-item>

          <el-form-item label="店铺" prop="shop_id"  v-if="userInfo.group_id == 96 ||  [1, 1737, 1901, 1916, 1917].includes(userInfo.id)">
            <el-select
              v-model="search.shop_id"
              clearable
              multiple
              filterable
              placeholder="请选择店铺"
            >
              <el-option
                v-for="item in options.shop_idList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

        </el-form>
      </el-col>
      <el-col :span="2" style="text-align: right;">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
      </el-col>
    </el-row>
    <div class="accountCon">
      <el-button  type="primary"  class="mb10" size="mini" @click="tapBtn('export')">导出数据</el-button>
      <el-button  type="primary"  size="mini" @click="goAdd" v-if="(!userInfo.is_zhiying  && [7,10].includes(userInfo.position_id) )||userInfo.group_id == 96 ||  [1, 1737, 1901, 1916, 1917].includes(userInfo.id)">新增商品</el-button>
      <el-button  type="primary"  size="mini" @click="tapBtn('claim')" v-if="[7,10].includes(userInfo.position_id) ">一键认领商品</el-button>
      <!--列表-->
      <el-row>
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
          >
            <ElTableColumn type="index" label="序号" width="50" />
            <ElTableColumn label="添加时间" prop="create_time" />
            <ElTableColumn label="商品名称" prop="name"  width="250"/>
			      <ElTableColumn label="商品编码" prop="kingdee_code" />
            <ElTableColumn label="商品分类" prop="category_name" />
            <ElTableColumn label="商品规格"  prop="spec_name" />
            <ElTableColumn label="商品单位" prop="unit_name" />
            <ElTableColumn label="单位编码" prop="unit_code" />
            <ElTableColumn label="销售价格(元)"  prop="goods_price" />
            <ElTableColumn label="商品单价"  prop="goods_sn" />
            <ElTableColumn label="商品类型"  prop="project" />
            <ElTableColumn label="适用类型"  prop="shoptype" v-if="userInfo.group_id == 96 ||   [1,1752, 1737, 1901, 1916, 1917].includes(userInfo.id)" />
            <ElTableColumn label="归属门店" prop="shop_name" v-if="userInfo.group_id == 96 ||  [1, 1737, 1901, 1916, 1917].includes(userInfo.id)"/>
            <ElTableColumn label="状态" width="150">
              <template slot-scope="{ row }">
                <el-switch
                  v-model="row.status"
                  :active-value="1"
                  :inactive-value="2"
                  active-text="上架"
                  inactive-text="下架"
                  :disabled="!row.can_edit_status || row.claim_status == '未认领'"
                  @change="handleStatusChange(row)"
                />
              </template>
            </ElTableColumn>
            <ElTableColumn label="操作"  fixed="right" >
              <template
                slot-scope="{ row }"
              >
                <span class="theme" @click="tapBtn('detail',row.id)"> 查看</span>
                <span class="theme" @click="tapBtn('update',row.id)" v-if="row.create_user_id == userInfo.id || (userInfo.group_id == 96 ||  [1, 1737, 1901, 1916, 1917].includes(userInfo.id) && row.claim_status)"> 编辑</span>
                <span class="theme" style="color: #E6A23C;" @click="tapBtn('claim',row.id)" v-if="[7,10].includes(userInfo.position_id) && row.claim_status == '未认领'"> 认领</span>
                <span class="peril" style="color: #F56C6C;" @click="tapBtn('del',row.id)" v-if="row.create_user_id == userInfo.id ||userInfo.group_id == 96 ||  [1, 1737, 1901, 1916, 1917].includes(userInfo.id)"> 删除</span>
              </template>
            </ElTableColumn>
          </el-table>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.limit"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import pagination from '@/components/Pagination'
import { readAdminMarketList1} from "@/api/shop";
import { goodsList,deleteGoods,exportGoods,categoryList,claimGoods,updateGoods} from '@/api/goods';

class Page {
  total = 0;
  page = 1;
  limit = 10;
}
class Search {
  name = ''; // 名称
  kingdee_code = ''; // 编码
  status = ''; // 状态
  category_id = []; // 分类
  goods_level = ''; // 权限
  is_prestock = ''; // 预存
  shop_id = []; // 店铺
  is_project = []; // 服务/产品
  shop_type = []; // 适用类型
}
class Options {
  shop_idList = [];
  claim_statusList = [
    {id: 1,name: "未认领"},
    {id: 2,name: "已认领"},
  ];
  is_prestock = [
    {id: 1,name: "是"},
    {id: 0,name: "否"},
  ];
  goods_level=[
    {id: 1,name: "公共商品"},
    {id: 2,name: "私有商品"},
  ];
  is_projectList = [
    {id: 1,name: "商品"},
    {id: 2,name: "服务"},
    {id: 3,name: "仪器"},
    {id: 4,name: "药品"},
    {id: 5,name: "耗材"},
  ];
   category_id = [];
   shop_typeList = [
    {id: 11,name: "直营",children:[
      {id: 1,name: "门店"},
      {id: 2,name: "门诊"},
      {id: 3,name: "双美"},
    ]},
    {id: 22,name: "加盟",children:[
      {id: 4,name: "门店"},
      {id: 5,name: "门诊"},
    ]}
 ];
  constructor () {
    this.status = [
      { id: 1, name: '销售中' },
      { id: 2, name: '已下架' }
    ] 
  }
}
export default {
  name: 'GoodsList',
  components: {
    pagination
  },
  data () {
    return {
      search: new Search(), // 检索条件
      options: new Options(), // 选项
      page: new Page(), // 分页
      list: [], // 数据展示
      idList: []
    }
  },
computed: {
    ...mapGetters(['userInfo']),
  },
  mounted () {
    this.getOptions()
    this.getList()
  },
  methods: {
    handleStatusChange(row){
      updateGoods({id:row.id,status:row.status} ).then(res => {
          this.$message({
            type: 'success',
            message: res.msg
          });
        this.getList('search')

      }).catch(err => {
        this.getList('search')
      })
    },
    getOptions(){
      categoryList({page:1,limit:10000}).then(res => {
        this.options.category_id = res.list;
      })
       readAdminMarketList1({action: "shop"}).then(res => {
          this.options.shop_idList = res;
        });
    },
    goAdd () {
      this.$router.push({name:'添加商品'})
    },
    // 获取列表
    getList (option) {
      if (option === 'search') this.page = new Page();
      goodsList({...this.search,...this.page}).then(res => {
        this.list = res.list;
        this.page.total = res.dataCount;
      })
    },
    // 点击按钮
    tapBtn (type,id) {
       switch (type) {
        case 'detail':
          this.$router.push('./goodsDetail?id=' + id)
          break
        case 'update':
          this.$router.push('./addGoods?id=' + id)
          break
        case 'del':
          this.hint(type,'删除',id)
          break
        case 'export':
          this.hint(type,'导出选中')
          break
        case 'claim':
          this.hint(type,'认领',id)
          break
      }
    },
    // 提示
    hint(type,text,id){
       this.$confirm(`确定${text}商品吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          switch (type) {
          case 'claim':
            this.claimGoods(id)
            break
          case 'del':
            this.delGoods(id)
              break
          case 'export':
            this.getExport()
              break
        }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
    },
    claimGoods(id){
      claimGoods({goods_id:id}).then(res => {
        this.$message({
          type: 'success',
          message: res.msg
        });
        this.getList()
      })
    },

    // 商品删除
    delGoods(id){
      deleteGoods({id}).then(res => {
        if(res.code === 200){
          this.$message({
              type: 'success',
              message: res.msg
          });
          this.getList()
        }else{
          this.$message({
              type: 'error',
              message: res.msg
          });
        }
      })
            
    },
    // 导出
    getExport(){
      exportGoods({...this.search}).then(res => {
        window.open(res.data.url);
      }) 
    },

    // 改变表格选中状态
    handleSelectionChange (val) {
      this.idList = val.map(i => {
        return i.id
      })
    }

  }
}
</script>

<style lang="scss" scoped>

.bgW {
  background: #fff;
  border-radius: 3px;
  margin-bottom: 20px;
}
.el-form-item {
  margin: 5px  40px  3px 0 ;
}
.accountCon{
    background: #fff;
    padding: 10px 0px 80px;
}
</style>
